/**
 * Централизованная конфигурация приложения
 */

// URLs
export const POCKETBASE_URL = import.meta.env.VITE_POCKETBASE_URL || 'http://127.0.0.1:8090';
export const API_URL = import.meta.env.VITE_API_URL || '';

// Environment
export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;

// Subscription limits (free tier)
export const FREE_TIER_LIMITS = {
  projects: 1,
  personas: 1,
  analyses: 1,
  positioning: 0,
  businessModel: 0,
  mvpPlans: 0,
  financialModel: 0,
  researchMessages: 0,
  mentorMessages: 10,
} as const;

// Subscription prices (RUB) — one-time payment
export const SUBSCRIPTION_PRICES = {
  basic: 990,
  full: 1490,
  // Legacy
  creator: 599,
  top_creator: 1490,
} as const;

// Site builder visibility.
//
// The builder ships in the bundle but stays hidden until it is product-ready.
// Staging turns it on via VITE_BUILDER_ENABLED=true (see deploy.yml); production
// leaves the variable unset, so the menu entry and the routes are absent there.
export const BUILDER_ENABLED = import.meta.env.VITE_BUILDER_ENABLED === 'true';

// Methodology engine visibility (F-02).
//
// Verified on staging and switched on in both builds in deploy.yml (2026-09-25).
// Without the flag, neither the sidebar entry nor the `/methods*` routes exist,
// and /research falls back to the persona interview without tabs.
export const METHODOLOGIES_ENABLED = import.meta.env.VITE_METHODOLOGIES_ENABLED === 'true';

// Site audit visibility (F-05).
//
// Same pattern again: the code ships, the section appears only where the flag is set.
// Staging turns it on in deploy.yml; production leaves it unset, so neither the sidebar
// entry nor the `/site-audit*` routes exist there.
export const SITE_AUDIT_ENABLED = import.meta.env.VITE_SITE_AUDIT_ENABLED === 'true';

// Tool picker (F-08). Staging turns it on via VITE_TOOLS_ENABLED=true (see deploy.yml).
export const TOOLS_ENABLED = import.meta.env.VITE_TOOLS_ENABLED === 'true';
